/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_waku.svg" class="icon" data-view="tablet sp" /></button>';

	// ローディングアニメーション
	const loading = () => {
		const loadingBlock = $('.top-loading');
		const gauge = $('.top-loading-gauge');
		let images = $('img');
		let count = 0;
		let current;

		// body縦スクロール非表示
		$('body').addClass(f);

		for(let i = 0; i < images.length; i++) {
			let img = new Image(); // 画像の作成
			count += 1;
			img.src = images[i].src; // 画像にsrcを指定して読み込み開始
			// 現在の読み込み具合のパーセントを取得
			current = Math.floor(count / images.length * 100);
			// ゲージの変更
			gauge.css('width', `${current}%`);
		};

		let nowLoading = setInterval(function() {
			// 全て読み込んだ時
			if(count == images.length) {
				setTimeout(() => {
					setTimeout(() => {
						loadingBlock.addClass('is-hidden');
						$('body').removeClass(f);	
						if($('.js-deliciousness-slider').length) {
							deliciousnessSlider();
						}
						if($('.js-pickup-slider').length) {
							pickupSlider();
						}
						setTimeout(() => {
							mainVisanimation();
						}, 800);
					}, 100);
				}, 800);
				clearInterval(nowLoading);
			}
		}, 100);

		// 高さ調整
		function setHeight(){
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		// 2.初期化
		setHeight();
		// 3.ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
		window.addEventListener('resize', setHeight);
	}

	// アニメーション
	const mainVisanimation = () => {
		const anime = 'is-animation';
		// メインビジュアル
		$('.js-animation-mainVis').on('inview', (event, isInView) => {
			$('.top-mainVis-bg').addClass(anime);
			$('.top-mainVis-h1').addClass(anime);
		});

		// ピックアップ
		$('.js-animation-pickup').on('inview', (event, isInView) => {
			$('.js-animation-pickup').addClass(anime);
		});

		// 特設・ブランドサイトなど
		let specialDelay = .4;
		$('.js-animation-special-item').each((idx, ele) => {
			$(ele).css('transition-delay', specialDelay +'s');
			specialDelay += .1;
		});
		specialSlider();
		$('.js-animation-special').on('inview', (event, isInView) => {
			$('.js-animation-special').addClass(anime);
		});

		// 理研ビタミンの業務用ソリューション
		$('.js-animation-business').on('inview', (event, isInView) => {
			$('.js-animation-business').addClass(anime);
		});
	};

	// ===========================================================================
	// 「おいしさの提案」スライド
	const deliciousnessSlider = () => {
		$('.js-deliciousness-slider').slick({
			infinite: true,
			speed: 800,
			autoplay: false,
			pauseOnHover: false,
			// autoplaySpeed: 5000,
			slidesToShow: 1,
			fade: true,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			appendDots: $('.top-deliciousness'),
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						speed: 500,
					}
				}
			]
		});
	};

	// ピックアップ
	const pickupSlider = () => {
		const sliderSetting = () => {
			var width = $(window).width();
			if(width <= 767) {
				const thisSlider = $('.js-pickup-slider');
				const thisSliderDots = thisSlider.next('.mod-slider-dots');
				thisSlider.not('.slick-initialized').slick({
					infinite: true,
					speed: 500,
					autoplaySpeed: 4000,
					autoplay: true,
					slidesToShow: 1,
					arrows: false,
					dots: true,
					appendDots: thisSliderDots,
				});

				// 再生ボタン
				thisSliderDots.find('button.__play').on('click', () => {
					thisSliderDots.toggleClass(a);
					thisSlider.slick('slickPlay');
				});
				// 停止ボタン
				thisSliderDots.find('button.__pause').on('click', () => {
					thisSliderDots.toggleClass(a);
					thisSlider.slick('slickPause');
				});
			} else {
				$('.js-pickup-slider.slick-initialized').slick('unslick');
			}
		};
		sliderSetting();

		$(window).resize(() =>{
			sliderSetting();
		});
	};

	// 特設・キャンペーン　スライド
	const specialSlider = () => {
		const thisSlider = $('.js-special-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		thisSlider.slick({
			infinite: true,
			speed: 1000,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 5000,
			slidesToShow: 4,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			appendDots: thisSliderDots,
			appendArrows: thisSliderDots,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 3,
						speed: 500,
					},
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
		// 再生ボタン
		thisSliderDots.find('button.__play').on('click', () => {
			thisSliderDots.toggleClass(a);
			thisSlider.slick('slickPlay');
		});
		// 停止ボタン
		thisSliderDots.find('button.__pause').on('click', () => {
			thisSliderDots.toggleClass(a);
			thisSlider.slick('slickPause');
		});
	};

	// 「おすすめ旬レシピ」スライド
	const recipeSlider = () => {
		$('.js-recipe-slider').slick({
			infinite: true,
			speed: 800,
			autoplay: false,
			pauseOnHover: false,
			slidesToShow: 1,
			fade: true,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			appendDots: $('.top-recipe-slideWrap'),
			appendArrows: $('.top-recipe-inner'),
			customPaging: function(slider, index) {
				$('.top-recipe-slide-item').eq(index).find('.__num').text('0' + Number(index + 1));
				return $('<button type="button" />').text('0' + Number(index + 1));
			},
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						speed: 500,
					}
				}
			]
		});
	};

	// 「ニュース」タブチェンジ
	const newsTabChange = () => {
		$('.js-news-tab-content').eq(0).addClass(a);
		$('.js-news-tabChange').eq(0).addClass(a);
		$('.js-news-tabChange').each((idx, val) => {
			$(val).on('click', () => {
				$('.js-news-tabChange').removeClass(a);
				$(val).addClass(a);
				$('.js-news-tab-content').removeClass(a);
				$('.js-news-tab-content').eq(idx).addClass(a);
			});
		});
	};


	// ==============================================================================
	loading();
	if($('.js-news-tabChange').length) {
		newsTabChange();
	}


})(window.jQuery, window.RIKEN);
